// extracted by mini-css-extract-plugin
export default {"callout":"ZDzQnkabedcX7JKiRGJH","typeColumn":"VayKbiGMsjMC6JPQs78I","typeLabel":"C_rmtPh6FICqmTP17WTg"};